import { useParams } from 'react-router-dom';
import PatientMaster from '../components/Patient/Master';
import Restricted from '../components/Restricted';
import TempPassword from '../components/TempPassword';
import { useDataContext } from '../contexts/DataContext';
import Layout from './Layout';

const PagePatientForm = () => {
    const { id } = useParams();

    const { currentUserId, currentUserTemporaryPassword } = useDataContext();

    if (currentUserTemporaryPassword)
        return (
            <Layout>
                <TempPassword />
            </Layout>
        );

    return <Layout>{currentUserId ? <PatientMaster id={id} /> : <Restricted />}</Layout>;
};

export default PagePatientForm;
